import { render } from "./user-assign-page.vue?vue&type=template&id=3cc593bc"
import script from "./user-assign-page.vue?vue&type=script&lang=js"
export * from "./user-assign-page.vue?vue&type=script&lang=js"

import "./user-assign-page.vue?vue&type=style&index=0&id=3cc593bc&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__